import OnSalePropertyAPI from './OnSalePropertyAPI';
export default OnSalePropertyAPI;
